var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52184_117358)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7049 9.42441C13.5825 3.83122 11.6969 -0.0183105 10.0014 -0.0183105C8.30584 -0.0183105 6.42008 3.83156 6.29787 9.42441H13.7049ZM7.57447 19.7193C3.39762 18.6782 0.251329 15.0081 0 10.5758H5.14761C5.23271 14.5451 6.17818 17.9054 7.57447 19.7193ZM10.0014 20.0185C8.30584 20.0185 6.42021 16.169 6.29787 10.5758H13.7049C13.5826 16.1686 11.6969 20.0185 10.0014 20.0185ZM0.00274277 9.42405C0.253977 4.99205 3.40019 1.32178 7.57721 0.280559C6.17827 2.09571 5.23143 5.45469 5.15032 9.42405H0.00274277ZM12.4255 19.7196C16.6026 18.6784 19.7488 15.0081 20 10.5761H14.8524C14.7713 14.5455 13.8245 17.9044 12.4255 19.7196ZM14.8524 9.42405C14.7673 5.45469 13.8218 2.09438 12.4255 0.280559C16.6024 1.32294 19.7513 4.99171 20 9.42405H14.8524Z",
    fill: "#E3ECF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52184_117358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageDark);
export default __webpack_public_path__ + "static/media/language_dark.af40fe270f5eef466ed36524b59c486f.svg";
export { ForwardRef as ReactComponent };